import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row wrap" }, "12 months KPIs", -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "col-2"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row text-caption justify-center" }, "Reliability", -1 /* HOISTED */)
const _hoisted_5 = {
  key: 1,
  class: "col-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "row text-caption justify-center" }, "Availability", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_CircularStats = _resolveComponent("CircularStats")!
  const _component_HoursStats = _resolveComponent("HoursStats")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_ctx.equipment)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_card, { class: "flex column" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row justify-between card-title flex-center" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_card_section, {
              class: _normalizeClass(["row items-center", _ctx.getEquipmentDetails.avRe ? 'justify-between' : 'justify-center'])
            }, {
              default: _withCtx(() => [
                (_ctx.getEquipmentDetails.avRe)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_CircularStats, {
                        class: "justify-center",
                        percent: _ctx.reliability
                      }, null, 8 /* PROPS */, ["percent"]),
                      _hoisted_4
                    ]))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_HoursStats, {
                  hours: _ctx.runHoursTotal,
                  status: _ctx.equipmentStatus.RUN
                }, null, 8 /* PROPS */, ["hours", "status"]),
                _createVNode(_component_HoursStats, {
                  hours: _ctx.runLimitedHoursTotal,
                  status: _ctx.equipmentStatus.RUN_LIMITED
                }, null, 8 /* PROPS */, ["hours", "status"]),
                _createVNode(_component_HoursStats, {
                  hours: _ctx.abnrHoursTotal,
                  status: _ctx.equipmentStatus.ABNR
                }, null, 8 /* PROPS */, ["hours", "status"]),
                _createVNode(_component_HoursStats, {
                  hours: _ctx.schHoursTotal,
                  status: _ctx.equipmentStatus.SCH
                }, null, 8 /* PROPS */, ["hours", "status"]),
                _createVNode(_component_HoursStats, {
                  hours: _ctx.unschHoursTotal,
                  status: _ctx.equipmentStatus.UNSCH
                }, null, 8 /* PROPS */, ["hours", "status"]),
                _createVNode(_component_HoursStats, {
                  hours: _ctx.nbrTripsTotal,
                  status: _ctx.equipmentStatus.UNSCH,
                  heading: 'Nbr Trip'
                }, null, 8 /* PROPS */, ["hours", "status"]),
                (_ctx.getEquipmentDetails.avRe)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_CircularStats, {
                        class: "justify-center",
                        percent: _ctx.availability
                      }, null, 8 /* PROPS */, ["percent"]),
                      _hoisted_6
                    ]))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_HoursStats, {
                  hours: _ctx.utilizationPercentage,
                  status: _ctx.equipmentStatus.UNSCH,
                  heading: 'UTILIZATION'
                }, null, 8 /* PROPS */, ["hours", "status"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["class"])
          ]),
          _: 1 /* STABLE */
        })
      ]))
    : _createCommentVNode("v-if", true)
}